import { Currency, StripeCurrencyHelper } from '@sparelabs/currency'

export class TipValidation {
  public static isAmountBelowMinimum = (amount: number, currency: Currency): boolean =>
    amount < StripeCurrencyHelper.minimumCharge(currency)
}
